import Slide from "../../../../../../components/Slide";
import QList from "../../../../../../components/QList";
import QHeader from "../../../../../../components/QHeader";

import BackgroundImage from "../../../../../../assets/_Chapters/_Images/background/PSA-Vollversorgung/6.webp";
import { Grid } from "@material-ui/core";

export default function BetrieblicheSicherheit() {
  return (
    <Slide
      background={{
        image: BackgroundImage,
        width: "50dvw",
        align: "right",
        position: "center",
      }}
    >
      <Grid container spacing={5} alignItems="center">
        <Grid item xs={6}>
          <QHeader title="Betriebliche Sicherheit" />
          <QList
            items={[
              "Vollständige Übernahme von Beschaffung bis Versorgung der Erste Hilfe in Ihrem Unternehmen",
              "Beratung hinsichtlich betrieblicher Kennzeichnung",
              "Sicherstellung der Verfügbarkeit im Notfall",
              "Reduzierung interner Prozessaufwände",
            ]}
          />
        </Grid>
        <Grid item xs={6}></Grid>
      </Grid>
    </Slide>
  );
}
